import { Link } from "react-router-dom";

import { Button } from "../components/ui/button";

export function NotFoundPage(): JSX.Element {
  return (
    <main className="mx-auto flex min-h-full max-w-md flex-col items-center justify-center gap-4 px-6 py-12 text-center">
      <p className="text-sm font-medium text-primary-600">404</p>
      <h1 className="text-3xl font-bold text-neutral-900">Page not found</h1>
      <p className="text-neutral-600">
        We couldn&apos;t find the page you were looking for.
      </p>
      <Link to="/">
        <Button variant="primary">Back to home</Button>
      </Link>
    </main>
  );
}
